module.exports = __webpack_public_path__ + "static/media/whale.175bf72e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/primary-interface/whale.svg
// module id = 625
// module chunks = 6